import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from 'components/IconButton/IconButton';
import { CloseIcon } from 'components/icons';
import PropTypes from 'prop-types';
import React from 'react';

export const ModalTitle = ({ title, onClose }) => {
  return (
    <>
      {title && (
        <DialogTitle
          variant="subtitle1"
          fontWeight={600}
          color="text.secondary"
        >
          {title}
        </DialogTitle>
      )}
      {onClose && (
        <IconButton
          variant="text"
          color="secondary"
          onClick={onClose}
          sx={() => ({
            position: 'absolute',
            right: 6,
            top: 6,
          })}
          icon={<CloseIcon />}
        />
      )}
    </>
  );
};

export const ModalContent = ({ children, ...props }) => {
  return (
    <DialogContent dividers sx={{ p: 4 }} {...props}>
      {children}
    </DialogContent>
  );
};

export const ModalActions = ({ children, ...props }) => {
  return (
    <DialogActions
      sx={{
        backgroundColor: 'background.paper3',
        p: 1.5,
      }}
      {...props}
    >
      {children}
    </DialogActions>
  );
};

const Modal = ({
  onClose,
  title,
  children,
  actions,
  disableContentWrapper = false,
  ...rest
}) => {
  return (
    <Dialog fullWidth scroll="paper" maxWidth="sm" open={true} {...rest}>
      <ModalTitle title={title} onClose={onClose} />
      {disableContentWrapper ? (
        children
      ) : (
        <ModalContent dividers>{children}</ModalContent>
      )}
      {actions && <ModalActions>{actions}</ModalActions>}
    </Dialog>
  );
};

Modal.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  actions: PropTypes.node,
  disableContentWrapper: PropTypes.bool,
};

export default Modal;
